// this is an autogenerated file from App/Auth/SignOut/mutation.graphql
import { gql } from 'Data/Api'

let query = gql`
mutation app__App_Auth_SignOut{
  auth_logout {
    ok
  }
}

`
export default query
